// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import { StyledMobileBoxItemRow } from '../../utils/Styles/DataBoxStyles';
import Switcher from '../../utils/FormWidgets/Switcher';

const ActivityMobileSwitchField = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  label,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  name,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onChange,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isEditMode,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  checked,
}) => {
  return (
    <StyledMobileBoxItemRow maxWidth='100%' isEditableRow>
      {label}:
      {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        <Switcher
          onChange={() => onChange(name)}
          checked={checked}
          onColor='#B62767'
          disabled={!isEditMode}
          style={{ marginLeft: '10px' }}
        />
      }
    </StyledMobileBoxItemRow>
  );
};

export default ActivityMobileSwitchField;
